export default "__VITE_ASSET__D4Bfj$yX__"